import {useState} from "react";

import styles from './NewsVideos.module.scss';
import { data } from './data';

const threshold = 3;

export const NewsVideos = () => {
    const [opened, setOpened] = useState(false);

    if (!data || !data.length) {
        return null;
    }

    const dataToShow = (opened || data.length < threshold ) ? data : data.slice(0, threshold);

    return (
        <div className={styles.block}>
            <div className={styles.header} id="photo">
                Видео
            </div>

            <div className={styles.items}>
                {dataToShow.map((item, i) => {
                    return (
                        <a
                            key={i}
                            className={styles.item}
                            href={item.link}
                            target="_blank"
                        >
                            <div
                                className={styles.imageWrapper}
                            >
                                <div
                                    className={styles.image}
                                    style={{
                                        backgroundImage: `url(${item.photo})`
                                    }}
                                />
                            </div>

                            <div className={styles.info}>
                                <div className={styles.title}>
                                    {item.title}
                                </div>

                                <div className={styles.date}>
                                    {item.date}
                                </div>
                            </div>
                        </a>
                    );
                })}
            </div>

            {data.length >= threshold && (
                <div className={styles.button} onClick={() => setOpened(!opened)}>
                    {opened ? "Скрыть" : "Показать всё"}
                </div>
            )}
        </div>
    );
}